import { ChartData } from 'chart.js';

export const useCostPerRoomChartData = (labels: string[], dataPoints: number[]) => {
  const baseDataset = {
    label: 'Cost Per Room',
    borderColor: 'rgb(147, 87, 153)',
    backgroundColor: 'rgba(147, 87, 153, 0.2)',
    tension: 0.1,
    pointRadius: 5,
    pointHoverRadius: 12,
    pointHoverBackgroundColor: 'rgba(147, 87, 153, 0.2)',
  };

  const CostPerRoomChartData: ChartData<'line'> = {
    labels: labels.slice(-3), // last 3 months
    datasets: [{
      ...baseDataset,
      data: dataPoints.slice(-3),
    }],
  };

  const CostPerRoomExpandedChartData: ChartData<'line'> = {
    labels,
    datasets: [{
      ...baseDataset,
      data: dataPoints,
    }],
  };

  return {
    CostPerRoomChartData,
    CostPerRoomExpandedChartData,
  };
};
